module.exports = __webpack_public_path__ + "img/doc_check.ffde9de3.svg";